import { FilterMatchMode } from 'primeng/api';
import { AuthConstants } from '../authorization/auth.constants';
import { Icons } from 'src/app/shared/utilities/icons';
import { IPopupConfig } from 'src/app/shared/interfaces/confirm-popup.interface';

export const PREVIEW_CASES = {
  WHATSAPP: 'WHATSAPP',
  SMS: 'SMS',
  EMAIL: 'EMAIL',
  RCS: 'RCS',
  PUSH_NOTIFICATION: 'PUSH_NOTIFICATION',
};

export const DASHBOARD_SECTIONS = {
  CAMPAIGNS: 'campaigns',
  SEGMENTS: 'segments',
  TEMPLATES: 'templates',
};

export const CAMPAIGN_STATUS = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
};

export const APPROVAL_TYPE = {
  LEGALLY: 'LEGALLY',
  TRAI: 'TRAI',
  META: 'META',
  DPM: 'DPM',
  GOOGLE: 'GOOGLE',
};

export const MEDIA_TYPE = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  DOC: 'DOCUMENT',
};

export enum TemplateStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  PENDING = 'PENDING',
  RETIRED = 'RETIRED',
  ALL = 'ALL',
  REJECTED = 'REJECTED',
}

export enum ShortenUrlStatus {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
}

export const SHORTENER_TYPE = {
  BSP: 'BSP',
  INHOUSE: 'INHOUSE',
};

export enum OrchestrationOptionsEnum {
  TCL = 'TCL',
  INHOUSE = 'INHOUSE',
}

export const MODE_OF_EXECUTION = {
  NORMAL: 'NORMAL',
  ORCHESTRATE: 'ORCHESTRATE',
  Orchestrate: 'Orchestrate',
};

export const EXTENSION = {
  PNG: 'PNG',
  JPEG: 'JPEG',
  JPG: 'JPG',
  PDF: 'PDF',
  EML: 'EML',
  CSV: 'CSV',
  DOC: 'DOC',
  XLS: 'XLS',
  XLSX: 'XLSX',
  MSG: 'MSG',
  MP4: 'MP4',
  GIF: 'GIF',
};

export const UPLOAD = {
  MAX_SIZE: 5242880,
  MAX_UPLOADS: 1,
  CONCURRENCY: 1,
  EMAIL_ATTACHMENT: {
    MAX_SIZE: 7000000,
  },
  MEDIA_ATTACHMENT: {
    MAX_SIZE: 15728640,
    IMAGE_MAX_SIZE: 5242880,
    VIDEO_MAX_SIZE: 10485760,
    DOC_MAX_SIZE: 10485760,
  },
  MEDIA_THUMBNAIL_ATTACHMENT: {
    VIDEO_MIN_SIZE: 20480,
    VIDEO_MAX_SIZE: 102400,
  },
  TEMPLATE_ATTACHMENT: {
    MAX_SIZE: 9437184,
  },
  FORM_ATTACHMENT: {
    LOGO_MAX_SIZE: 200000,
    BANNER_MAX_SIZE: 500000,
  },
  RCS_MEDIA_ATTACHMENT: {
    REGULAR: {
      IMAGE_MAX_SIZE: 2097152,
      VIDEO_MAX_SIZE: 5242880,
      DOC_MAX_SIZE: 5242880,
    },
    CAROUSEL: {
      IMAGE_MAX_SIZE: 1048576,
      VIDEO_MAX_SIZE: 5242880,
    },
  },
};

export const INPUT = {
  APPROVALS_REQ: 3,
  PUSH_APPROVALS_REQ: 2,
  AMOUNT: {
    MIN: 100,
    MAX: 990000000,
  },
  MAX_LENGTH: {
    TEXTAREA: 1024,
    SMS: 160,
    RCS_TITLE: 200,
    RCS_CONTENT: 2500,
    RCS_MEDIA_CONTENT: 2000,
    EVENT_DESC: 2048,
    STATIC_URL: 1900,
    PUSH_TITLE: 150,
    PUSH_CONTENT: 1000,
  },
  FORM: {
    BASE_SIZE: 1000,
    FIREBASE_MAX_LENGTH: 128,
    RCS: {
      NAME_MAX_LENGTH: 100,
      GOOGLE_TEMP_MAX_LENGTH: 20,
    },
    FORM_NAME: {
      MIN_LENGTH: 2,
      MAX_LENGTH: 100,
      REGEX: /^[A-Za-z0-9/\-+.,&();:*? ]+$/,
    },
    FORM_DESC: {
      MIN_LENGTH: 2,
      MAX_LENGTH: 2000,
    },
    FOOTER: {
      MAX_LENGTH: 4000,
    },
    REGEX: {
      ONLY_NUMBERS: /^\d*$/,
      ALLOW_ALL: /^[A-Za-z0-9@~`!#$%^&*()_=+\\';:\"\\/?>.<{}\[\]|,\s-]*$/i,
      LATITUDE: /^[-+]?(90(\.0{1,7})?|[0-8]?\d(\.\d{1,7})?)$/,
      LONGITUDE:
        /^[-+]?(180(\.0{1,7})?|1[0-7]\d(\.\d{1,7})?|[0-9]?\d(\.\d{1,7})?)$/,
      MOBILE_NUMBER: /^[6-9]\d{9}$/,
      ALPHABETS_SPACES: /^[a-zA-Z ]*$/,
      ALPHANUMERIC_SPACES: /^[a-zA-Z0-9 ]*$/,
      HTTPS_URL:
        /^(https?:\/\/)([a-zA-Z0-9.-]+)\.[a-zA-Z]{2,}(:\d+)?(\/[a-zA-Z0-9._~+\-\/@%&=]*)?(\?[a-zA-Z0-9._~+\-\/@%&=]*)?$/,
      BASE_URL:
        /^(https?:\/\/|www\.)[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?::\d+)?(\/[a-zA-Z0-9._~+\-\/@%&=]*)?(?:\?[a-zA-Z0-9._~+\-\/@%&=]*)?$/,
    },
    CAMAIGN_NAME: {
      MIN_LENGTH: 2,
      MAX_LENGTH: 50,
      REGEX: /^[A-Za-z0-9-_]+$/,
    },
  },
};

export const ROUTES = {
  HOME: 'dashboard',
  TEMPLATES: 'templates',
  SEGMENTS: 'segments',
  CAMPAIGNS: 'campaigns',
  CAMPAIGN_SCHEDULER: 'campaign-scheduler',
  REPORTS: 'reports',
  FILE: 'upload-file',
  FORM_DESIGN: 'form-design',
  CONFIGURATION: 'configuration',
  WABA_LISTING: 'waba',
  RELOAD_CACHE: 'reload-cache',
  QLIK_SENSE_REPORT: 'qlik-sense',
  SENDER_EMAIL: 'sender-email',
  VIEW: 'view',
  SHORTEN_URL: 'shorten-url',
  BUDGET_MANAGEMENT: 'budget-management',
  CAMPAIGN_INSIGHTS: 'home',
};

export const FILE_TYPE = {
  EMAIL: 'EMAIL',
  WHATSAPP_IMAGE: 'IMAGE',
  WHATSAPP_VIDEO: 'VIDEO',
  WHATSAPP_DOCUMENT: 'DOCUMENT',
  VARIABLE: 'VARIABLE',
  LOGO: 'LOGO',
  BANNER: 'BANNER',
  VIDEO_THUMBNAIL: 'VIDEO_THUMBNAIL',
};

export const GRID_DATA_TYPE = {
  MORE: 'more',
  DATE: 'date',
  LINK: 'link',
  TEXT: 'text',
  NUMBER: 'number',
  DROPDOWN: 'dropdown',
  MULTISELECT: 'multiselect',
  RESPONSE_TYPE: 'responseType',
  IMAGE: 'image',
  RESPONSE_VALUE: 'responseValue',
  DEPENDENT_SEQUENCE: 'dependentSequence',
  SKIP_SEQUENCE: 'skipSequence',
  SCRIPT: 'script',
  ACTION_BUTTON: 'actionButton',
};

export const matchModeOptionsForFilter = [
  {
    label: 'Equals',
    value: FilterMatchMode.EQUALS,
  },
  {
    label: 'Contains',
    value: FilterMatchMode.CONTAINS,
  },
  {
    label: 'Not Contains',
    value: FilterMatchMode.NOT_CONTAINS,
  },
];

export const Regex = {
  TEXTAREA_REGEX: /^[^@{}\[\]=!~^$%<>`"]*$/,
  TEXT_REGEX: /^[^@#{}\[\]=!~^$%<>`"]*$/,
  CHOICES_REGEX: /^[\w\s<>,.?/\\;:"'@#!%&₹~*()\-_+=]*$/,
  WABA_NAME_REGEX: /^[a-zA-Z0-9_]+$/,
  WABA_DESC: /^[a-zA-Z0-9 ]+$/,
  META_TEMPLATE_NAME: /^[A-Za-z0-9_]+$/,
  FIEBASE_TEMPLATE_NAME: /^[A-Za-z0-9_-]+$/,
  DOMAIN_NAME: /^[a-zA-Z0-9.\-_]+$/,
  SUB_DOMAIN_NAME: /^[a-zA-Z0-9.!#$%&'*+/=?^_{|}~]+$/,
  EMAIL_CONTENT:
    /^(?:<[^>]+>|[A-Za-z0-9!@#$₹%&*()\-+=,;:'"_?\/\\.\s\n]|\p{Extended_Pictographic})*$/u,
  PUSH_TEMP_NAME: /^[a-zA-Z0-9()\-_ ]+$/,
  NUMBER_DECIMAL_ONLY: /^\d+(\.\d{1,2})?$/,
};

export const GRID_NAME = {
  TEMPLATE_LISTING: 'TEMPLATE_LISTING',
  WABA_LISTING: 'WABA_LISTING',
  FORM_LISTING: 'FORM_LISTING',
  SEGMENT_LISTING: 'SEGMENT_LISTING',
  SCHEDULER_LISTING: 'SCHEDULER_LISTING',
  CAMPAIGN_LISTING: 'CAMPAIGN_LISTING',
  FILE_UPLOAD_LISTING: 'FILE_UPLOAD_LISTING',
  SENDER_EMAIL_LISTING: 'SENDER_EMAIL_LISTING',
  SHORTEN_URL_LISTING: 'SHORTEN_URL_LISTING',
  API_SCHEDULER_LISTING: 'API_SCHEDULER_LISTING',
};

export const SIDE_NAV = [
  {
    name: 'Home',
    route: ROUTES.CAMPAIGN_INSIGHTS,
    activeIcon: 'assets/svg/common/home_active.svg',
    inActiveIcon: 'assets/svg/common/home_inactive.svg',
    permission: AuthConstants.SMART_OPTIMIZER,
  },
  {
    name: 'Web Form Designer',
    route: ROUTES.FORM_DESIGN,
    activeIcon: 'assets/svg/common/web_form_active.svg',
    inActiveIcon: 'assets/svg/common/web_form_inactive.svg',
    permission: AuthConstants.WEB_FORM,
  },
  {
    name: 'Template',
    route: ROUTES.TEMPLATES,
    activeIcon: 'assets/svg/common/template_active.svg',
    inActiveIcon: 'assets/svg/common/template_inactive.svg',
    permission: AuthConstants.TEMPLATE,
  },
  {
    name: 'Campaigns',
    route: ROUTES.CAMPAIGNS,
    activeIcon: 'assets/svg/common/campaign_active.svg',
    inActiveIcon: 'assets/svg/common/campaign_inactive.svg',
    permission: AuthConstants.CAMPAIGN,
  },
  {
    name: 'Target Segment',
    route: ROUTES.SEGMENTS,
    activeIcon: 'assets/svg/common/segment_active.svg',
    inActiveIcon: 'assets/svg/common/segment_inactive.svg',
    permission: AuthConstants.TARGET_SEGMENT,
  },
  {
    name: 'Campaign Scheduler',
    route: ROUTES.CAMPAIGN_SCHEDULER,
    activeIcon: 'assets/svg/common/campaign_scheduler_active.svg',
    inActiveIcon: 'assets/svg/common/campaign_scheduler_inactive.svg',
    permission: AuthConstants.CAMPAIGN_SCHEDULER,
  },
  {
    name: 'Budget Management',
    route: ROUTES.BUDGET_MANAGEMENT,
    activeIcon: 'assets/svg/common/budget_management_active.svg',
    inActiveIcon: 'assets/svg/common/budget_management_inactive.svg',
    permission: AuthConstants.BUDGET_MANAGEMENT,
  },
  {
    name: 'Reports',
    route: ROUTES.REPORTS,
    activeIcon: 'assets/svg/common/reports_active.svg',
    inActiveIcon: 'assets/svg/common/reports_inactive.svg',
    permission: AuthConstants.REPORT,
  },
  {
    name: 'Shorten URL',
    route: ROUTES.SHORTEN_URL,
    activeIcon: 'assets/svg/common/shorten_url_active.svg',
    inActiveIcon: 'assets/svg/common/shorten_url_inactive.svg',
    permission: AuthConstants.SHORTEN_URL,
  },
  {
    name: 'Configuration',
    route: ROUTES.CONFIGURATION,
    activeIcon: 'assets/svg/common/configuration_active.svg',
    inActiveIcon: 'assets/svg/common/configuration_inactive.svg',
    permission: AuthConstants.CONFIGURATION,
    showChildren: false,
    children: [
      {
        name: 'WABA Number',
        route: ROUTES.WABA_LISTING,
        permission: AuthConstants.CONFIGURATION_WABANUMBER,
      },
      {
        name: 'Reload Cache',
        route: ROUTES.RELOAD_CACHE,
        permission: AuthConstants.CONFIGURATION_RELOADCACHE,
      },
      {
        name: 'Sender Email ID',
        route: ROUTES.SENDER_EMAIL,
        permission: AuthConstants.CONFIGURATION_EMAIL,
      },
    ],
  },
];

export const CommonMessages = {
  ERROR: {
    NOT_ENOUGH_PERMISSION:
      'You do not have enough screen permissions to access this application. Please contact your Admin.',
    SOME_ERROR_OCCURED: 'Some error occured, please contact Admin.',
    SERVICE_UNAVILABLE_ERROR:
      'Resource Unavailable. Please try after some time.',
  },
};

export const CHANNELS_MAP: any /**NOSONAR */ = {
  SMS: {
    key: 'SMS',
    icon: Icons.SMS,
    label: 'SMS',
  },
  WHATSAPP: {
    key: 'WHATSAPP',
    icon: Icons.WHATSAPP,
    label: 'WhatsApp',
  },
  EMAIL: {
    key: 'EMAIL',
    icon: Icons.EMAIL,
    label: 'Email',
  },
  RCS: {
    key: 'RCS',
    icon: Icons.RCS,
    label: 'RCS',
  },
  PUSH_NOTIFICATION: {
    key: 'PUSH_NOTIFICATION',
    icon: Icons.PUSH_NOTIFICATION,
    label: 'Push Notification',
  },
  INHOUSE_ORCHESTRATION: {
    key: 'Inhouse',
    icon: Icons.INHOUSE_ORCHESTRATION,
    label: 'Inhouse Orchestration',
  },
  TCL_ORCHESTRATION: {
    key: 'TCL',
    icon: Icons.TCL_ORCHESTRATION,
    label: 'TCL Orchestration',
  },
};

export const SEGMENTS_MAP: any = {
  Manual: {
    key: 'Manual',
    icon: Icons.STANDALONE,
    label: 'Manual',
  },
  Automated: {
    key: 'Automated',
    icon: Icons.LQS,
    label: 'Automated',
  },
};

export const API_INTEGRATED = 'API Integrated';

export const SEGMENT_TYPE = {
  MANUAL: 'Manual',
  AUTOMATED: 'Automated',
  API: 'API',
};

export const TEST_TEMPLATE = {
  LANDING: 'LANDING',
  SUBJECT_PLACEHOLDER: 'SUBJECT_PLACEHOLDER',
  TITLE: 'TITLE',
  PLACEHOLDER: 'PLACEHOLDER',
  ADDITIONAL_PARAMS: 'ADDITIONAL_PARAMS',
  TINY_URL: 'TINY_URL',
  TINY_BUTTON_URL: 'TINY_BUTTON_URL',
  CALLBACK: 'CALLBACK',
  MEDIA_PLACEHOLDER: 'MEDIA_PLACEHOLDER',
  MEDIA_WEB: 'MEDIA_WEB',
  CTA: 'CTA',
  CAROUSEL: 'CAROUSEL',
  RESPONSES: 'RESPONSES',
  SUCCESS: 'SUCCESS',
};

export const REGEX = {
  ALPHANUMERIC_WITH_SUH: /^[A-Za-z0-9/\-_ ]+$/,
  ALPHANUM_SUH: /^[A-Za-z0-9\-_]+( [A-Za-z0-9\-_]+)*$|^[A-Za-z0-9\-_]+$/,
  APLHA_WITH_SPACES_UNDERSCORE_NO_WHITESPACE: /^[A-Za-z_]+(?:\s+[A-Za-z_]+)*$/,
  BUSINESS_DIVISION_NO_NUMBERS: /^[A-Za-z_]+(?:\s[A-Za-z_]+)*$/,
};

export const OrchestrationOptions = {
  TCL: 'TCL',
  INHOUSE: 'Inhouse',
};

export const SegmentButtonType = {
  GENERATE: 'GENERATE',
  MAP: 'MAP',
  UPLOAD: 'UPLOAD',
};

export const MODULE_NAME = {
  TEMPLATE: 'TEMPLATE',
  CONFIGURATION: 'CONFIGURATION',
  FORMS: 'FORMS',
  SEGMENT: 'SEGMENT',
  CAMPAIGN: 'CAMPAIGN',
};

export const TEST_TEMPLATE_CARD_HEADINGS: { [key: string]: string } = {
  titlePlaceholders: 'Card Title',
  placeholders: 'Card Description',
  tinyUrl: 'Tiny URL',
  callbackPlaceholders: 'Callback CTA Placeholder',
  mediaPlaceholders: 'Media Placeholder',
};

const TESTING_TEMPLATE = 'Testing Template';

export const TEST_TEMPLATE_HEADINGS = {
  LANDING: { blueText: TESTING_TEMPLATE, blackText: '' },
  SUBJECT_PLACEHOLDER: {
    blueText: TESTING_TEMPLATE,
    blackText: ' - Subject',
  },
  TITLE: {
    blueText: TESTING_TEMPLATE,
    blackText: ' - Card Title Variables',
  },
  PLACEHOLDER: {
    blueText: TESTING_TEMPLATE,
    blackText: ' - Content Variables',
  },
  TINY_URL: {
    blueText: 'Testing Template',
    blackText: ' - Tiny Url Variables',
  },
  TINY_BUTTON_URL: {
    blueText: 'Testing Template',
    blackText: ' - Button Url Variables',
  },
  CALLBACK: {
    blueText: TESTING_TEMPLATE,
    blackText: ' - Dynamic Callback Variables',
  },
  MEDIA_WEB: {
    blueText: TESTING_TEMPLATE,
    blackText: ' - Media & Web Form',
  },
  MEDIA_PLACEHOLDER: {
    blueText: TESTING_TEMPLATE,
    blackText: ' - Media Variables',
  },
  CTA: {
    blueText: TESTING_TEMPLATE,
    blackText: ' - Dynamic URL Variables',
  },
  ADDITIONAL_PARAMS: {
    blueText: TESTING_TEMPLATE,
    blackText: ' - Additional Parameters',
  },
  CAROUSEL: {
    blueText: TESTING_TEMPLATE,
    blackText: ' - Carousel Card Variables',
  },
  RESPONSES: { blueText: '', blackText: '' },
  SUCCESS: { blueText: '', blackText: '' },
};

export const TINY_URL_VALUE = 'placeholder_tiny1';
export const TINY_URL_CODE = '#placeholder_tiny1#';
export const TINY_URL_REGEX = /^#placeholder_tiny\d+#$/u;
export const TINY_URL_VALUE_REGEX = /^placeholder_tiny\d+$/u;
export const TINY_BUTTONS_REGEX = /^button_tiny\d+$/u;
export const TINY_BUTTONS_CODE_REGEX = /^#button_tiny\d+#$/u;

export const PLACEHOLDER_KEYS = {
  SUBJECT_PLACEHOLDER: 'subjectPlaceholders',
  TITLE: 'titlePlaceholders',
  PLACEHOLDER: 'placeholders',
  TINY_URL: 'tinyUrl',
  TINY_BUTTON_URL: 'tinyButtonUrl',
  CALLBACK: 'callbackPlaceholders',
  MEDIA_PLACEHOLDER: 'mediaPlaceholders',
};

export const TEST_TEMPLATE_ERROR_MSGS = {
  CALLBACK: 'Only numbers, with a length between 3 and 15 digits allowed',
  FORM: 'URL should start with www, http or https',
  MEDIA_PLACEHOLDERS_IMG: 'Only jpg, jpeg, png extensions allowed',
  MEDIA_PLACEHOLDERS_VIDEO: 'Only mp4 extension allowed',
  MEDIA_PLACEHOLDERS_DOC: 'Only pdf extension is allowed',
  MEDIA_PLACEHOLDERS_THUMBNAIL: 'Only jpg, jpeg, png, gif extensions allowed',
  PLACEHOLDERS: 'Only 40 characters allowed',
  PLACEHOLDERS_500: 'Only 500 characters allowed',
};

export const TEST_PUSH_TEMPLATE_ERROR_MSGS = {
  PLACEHOLDERS: 'Only 40 characters allowed',
  TITLE: 'Only alphanumeric values (1-150 characters) allowed.',
  MOBILE_NUMBER: 'Mobile number should start with 6,7,8,9 and of 10 digits',
  SVOC_ID: 'Invalid SVOC ID: only 5-15 digit numbers allowed',
  REGISTRATION_NUMBER:
    'Invalid Registration number: only alphanumeric values (6-15 characters) allowed.',
  SURVEY_ID:
    'Input must be of 8 alphanumeric characters (no special characters).',
};

export const IMAGE_EXTENTIONS = ['.jpg', '.jpeg', '.png'];
export const VIDEO_EXTENTIONS = ['.mp4'];
export const DOC_EXTENTIONS = ['.pdf'];

export const TEST_TEMP_REGEX = {
  MOBILE: /^[6-9]\d{9}$/, // mobile numbers starting with 6,7,8,9 and of 10 digits
  EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, // standard email validation
  CALLBACK_MOBILE: /^\d{3,15}$/, // callback mobilr validation
  MOBILE_NO_START: /^[6-9]/, // mobile number should start with 6,7,8,9
  NUMERIC_ONLY_5_TO_15: /^\d{5,15}$/, // Allow only numeric values for SVOC ID, minimum characters 5 and maximum characters 15, no special characters allowed.
  ALPHANUMERIC_6_TO_15: /^[a-zA-Z0-9]{6,15}$/, // Allow alphanumeric values, minimum characters 6 and maximum characters 15, no special characters allowed.
  // Input must be an 8-digit number without special characters and spaced not allowed
  SURVEY_ID: /^[a-zA-Z0-9]{8}$/,
};

export const SUCCESS_SECTION_CONST = {
  CONFIRMATION: 'CONFIRMATION',
  RE_INITIATE: 'RE_INITIATE',
  ACTION_COMPLETION: 'ACTION_COMPLETION',
  SUCCESS_MESSAGE: 'SUCCESS_MESSAGE',
  ADD_MORE: 'ADD_MORE',
};

export const SUCCESS_SECTION_LIST = [
  SUCCESS_SECTION_CONST.CONFIRMATION,
  SUCCESS_SECTION_CONST.RE_INITIATE,
  SUCCESS_SECTION_CONST.ACTION_COMPLETION,
  SUCCESS_SECTION_CONST.SUCCESS_MESSAGE,
  SUCCESS_SECTION_CONST.ADD_MORE,
];

export const ALLOWED_EXTENSION_RINGI = [
  'PDF',
  'CSV',
  'XLSX',
  'DOC',
  'DOCX',
  'JPEG',
  'JPG',
  'PNG',
];

export const SHORTEN_URL_CONST = 'https://cm.shrtn.url.com/';

export const placeholderMaxLength = 40;

export const CHANNEL_SEQUENCE: readonly string[] = [
  'SMS',
  'WhatsApp',
  'RCS',
  'Email',
  'Push Notification',
];

export const INSUFFICIENT_BUDGET_ERROR_MESSAGE =
  'Campaign cannot be scheduled due to insufficient funds. Please add funds to continue';

export const BSP_INFO_TOOLTIP =
  'BSP-provided URL shortening is no longer available. In-house URL shortening will be applied by default.';

export const BSP_INFO_TOOLTIP_SEGMENT =
  'BSP-provided orchestration is no longer available. In-house multichannel orchestration will be applied by default.';

export const CANCEL_POPUP_CONFIG: IPopupConfig = {
  headerConfig: {
    icon: 'bi bi-exclamation-triangle',
    isCloseBtn: true,
    title: 'Confirm Action',
  },
  bodyConfig: {
    text: 'Are you sure you want to cancel this Campaign?',
    elements: [
      {
        text: 'Reason for Cancellation*',
        type: 'textarea',
        isMandatory: true,
        response: '',
        maxCharLength: 200,
        minCharLength: 1,
      },
    ],
  },
  footerConfig: {
    isCancelButton: true,
    isConfirmButton: true,
  },
};

export function parseDate(dateStr: string, _format: string): Date | null {
  if (!dateStr) return null;
  // Handles DD/MM/YYYY HH:mm or DD-MM-YYYY HH:mm
  const cleaned = dateStr.replace(/-/g, '/');
  const parts = cleaned.split(' ');
  if (parts.length < 2) return null;
  const d = parts[0].split('/');
  const t = parts[1].split(':');
  if (d.length < 3 || t.length < 2) return null;
  return new Date(
    Number(d[2]),
    Number(d[1]) - 1,
    Number(d[0]),
    Number(t[0]),
    Number(t[1]),
  );
}
